import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default {
  template: html,
  components: {  },
  props: {
    message: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    }
  }, 
  setup() {
    // Injections
    const { t } = useI18n();
    return {
        t
    }
  }
}